// extracted by mini-css-extract-plugin
export var sparkGrid = "SparkThreeUp-module--spark-grid--j-9Rr";
export var grey = "SparkThreeUp-module--grey--3T69N";
export var subtitle = "SparkThreeUp-module--subtitle--SSyKJ";